export { PageUsersFormComponent as PageUsersDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/users-form/index.tsx